import { withModalConditionalRender } from '@billy/design-system'
import Cookies from 'js-cookie'
import { useMemo } from 'react'

import { InvoiceStatus } from '@features/invoices/enums/invoiceStatus'
import { mapBillyExternalInvoiceToInvoice } from '@features/invoices/utils/mapBillyExternalInvoiceToInvoice'
import { Invoice } from '@features/invoicesLegacy/types/invoice'
import { AccountingBasis } from '@modules-deprecated/app/organization/types/accountingBasis'

import { CookieKeys } from '../../../../../../../../enums/cookieKeys'
import { ModalId } from '../../../../../../../../enums/modalId'
import { useInvoice } from '../../../../../../../externalInvoices/routes/InvoiceView/contexts/invoiceContext'
import { InvoiceReconciliationModal as InvoiceReconciliationModalComponent } from '../../../../../../../invoices/elements/InvoiceReconclliationModal/InvoiceReconciliationModal'

const InvoiceReconciliationModal = withModalConditionalRender(InvoiceReconciliationModalComponent)

export const RegisterPaymentModal = () => {
  const { invoice, billyApiExternalInvoice, invoiceId } = useInvoice()

  // "Register payment" quick action from the invoices list triggers the force render of
  // this modal. We deliberately keep the cookie set (instead of clearing it on open)
  // so the list can detect the pending payment and poll for the synced paid status once
  // the user navigates back to the list. The list is responsible for clearing this cookie.
  const shouldForceRender = Cookies.get(CookieKeys.InvoiceViewRegisterPaymentRequest) === invoiceId

  const invoiceData: Invoice | undefined = useMemo(() => {
    if (!billyApiExternalInvoice) {
      return undefined
    }
    const mappedInvoice = mapBillyExternalInvoiceToInvoice(billyApiExternalInvoice)
    return {
      ...mappedInvoice,
      invoiceNo: invoice?.invoiceNumber || 'from-billy',
      isPaid: invoice?.status?.status === InvoiceStatus.Paid,
    }
  }, [billyApiExternalInvoice, invoice])

  const isCashBasis = useMemo(
    () => billyApiExternalInvoice?.accountingBasis === AccountingBasis.Cash,
    [billyApiExternalInvoice],
  )

  return (
    <>
      {invoiceData && (
        <InvoiceReconciliationModal
          forceRender={shouldForceRender}
          subject={invoiceData}
          id={ModalId.InvoiceReconciliationModal}
          isCashBasis={isCashBasis}
        />
      )}
    </>
  )
}
